import { Button } from '@material-ui/core';
import React from 'react';

import useServicesExport from 'core/hooks/useServicesExport';

export default function ServiceExportButton() {
  const url = useServicesExport();

  return (
    <Button
      component="a"
      href={url}
      target="_blank"
      variant="contained"
      color="secondary"
    >
      Hae työ- & tarvikelista
    </Button>
  );
}
